import icEmergency from "assets/images/ic-lightbulb-01.svg"
import Button from "components/commons/button"
import DeleteModal from "components/commons/delete-modal"
import Table from "components/commons/table"
import { TABLE_EMERGENCY_CONTACT } from "configs/employee/configTableAddEmployee"
import { useExpandable } from "hooks/useExpandable"
import { CreateFamily } from "../create-modal/CreateFamily"
import { FormHeader } from "./FormHeader"

export const EmergencyContactInformation = ({
    optionsFamilyRelationship,
    dataEmergency,
    errorForm,
    isFormValid,
    isEdit,
    form,
    showModal,
    onShowModal,
    onCloseModal,
    onChangeForm,
    onSubmit,
    onActionRow,
    showDeleteModal,
    onCloseDeleteModal,
    onDelete,
}) => {
    const { isExpanded, elementRef, toggleExpand } = useExpandable({ verticalPadding: 24 })

    return (
        <div className="bg-white border-y border-neutral-20">
            <FormHeader title="Informasi Kontak Darurat" optional icon={icEmergency} expanded={isExpanded} onClick={toggleExpand} />
            <div ref={elementRef} className="expandable px-8">
                <Table
                    className="mb-5"
                    classNameHeader="!bg-primary-10 !text-md !text-primary-50"
                    classNameRow="!py-6"
                    name={TABLE_EMERGENCY_CONTACT.name}
                    columns={TABLE_EMERGENCY_CONTACT.column}
                    data={form}
                    onClickItem={onActionRow}
                />
                <Button type="outline" title="+ Tambah Kontak Darurat" onClick={onShowModal} />
            </div>

            <CreateFamily
                title="Kontak Darurat"
                errorForm={errorForm}
                isFormValid={isFormValid}
                isEdit={isEdit}
                show={showModal}
                onHide={onCloseModal}
                optionsFamilyRelationship={optionsFamilyRelationship}
                dataFamily={dataEmergency}
                onChangeForm={onChangeForm}
                onSubmit={onSubmit}
            />

            <DeleteModal
                text={"Apakah anda yakin ingin menghapus kontak darurat?"}
                show={showDeleteModal}
                onHide={onCloseDeleteModal}
                onDelete={onDelete}
            />
        </div>
    )
}